<template>
    <div class="row p-3">
        <input-textarea class="col-12" label="Descrição" v-model="form.descricao" ref="descricao" required :max-length="500" placeholder="Máximo 500 caracteres"/>
        <div class="col-12">
            <b-button  variant="success" v-if="controlesLiberados && permissao.u"  @click="salvar">
                <i class="fa-solid fa-check mr-2"></i>
                Salvar
            </b-button>
        </div>
    </div>
</template>
<script>

import InputTextarea from "@/components/inputs/InputTextarea.vue";

import {FormMixin} from "@/common/mixins/FormMixin";

export default {
    name: "TransferenciaTecnologica",
    mixins: [FormMixin],
    components: {
        InputTextarea,
    },
    props : {
        objeto : {
            type : Object,
            default : () => ({
                descricao: "",
            })
        },
        projetoEditavel : {
            type : Boolean,
            default : false
        }
    },
    data : () => ({
        options : {
            simnao : [
                { id : "S", text : "Sim" },
                { id : "N", text : "Não" },
            ]
        },
        form : {
            descricao : "",
        }
    }),
    methods : {
        salvar : function(){
            this.$emit("salvar", this.form);   
        }
    },
    watch : {
        objeto : {
            handler : function(val){
                if(val)
                    this.form = val;
            },
            deep : true,
            immediate : true
        }
    },
    
    computed : {
        controlesLiberados :function(){
            return this.projetoEditavel
        },
        permissao() {
            return this.$store.getters['app/retornaPermissao']('ProjetosPdCaracteristicaProjeto');
        },
    }
}
</script>
<style lang="">
    
</style>